const NAMED_ENTITIES: Record<string, string> = {
	nbsp: " ",
	amp: "&",
	lt: "<",
	gt: ">",
	quot: '"',
	apos: "'",
}

/** Turns the HTML entities left in text stripped of its tags back into characters. */
export function decodeHtmlEntities(text: string): string {
	return text.replace(
		/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi,
		(match, entity: string) => {
			if (entity.startsWith("#")) {
				const code =
					entity[1]?.toLowerCase() === "x"
						? Number.parseInt(entity.slice(2), 16)
						: Number.parseInt(entity.slice(1), 10)
				if (!Number.isFinite(code) || code < 1 || code > 0x10ffff) return match
				return code === 0xa0 ? " " : String.fromCodePoint(code)
			}
			return NAMED_ENTITIES[entity.toLowerCase()] ?? match
		},
	)
}
